import React from 'react';
import classnames from 'classnames';
import {findFilesByTypeId, getMediaType} from '../../../utils/files';
import Media from "../../Media";
import {getFullDataURI} from "../../../utils/getFullDataURI";
import styles from './styles.module.scss';

const IMAGES_PER_ROW = 2;

const HeaderLine = ({header}) => (
  <div className={classnames(styles.bold, styles.marginVert, styles.innerPadding)}>
    {header}
  </div>
);

const chunk = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

export const mapPDF = ({
                         file,
                         firstPageHeader,
                         className,
                       }) => {
  const convertedPages = Array.isArray(file?.convertedPages)
    ? file.convertedPages
    : [];
  const showFirstPageHeader = index => (index === 0) && Boolean(firstPageHeader);

  return convertedPages.filter(Boolean).map((fileSrc, index) => (
    <div key={index} className={className}>
      {showFirstPageHeader(index) && (
        <div>{firstPageHeader}</div>
      )}
      <div className={classnames(styles.freeText, styles.bold, styles.textRegular)}>
        {file?.free_text ?? ''}
      </div>
      <div className={classnames(styles.mediaContainer, styles.bottomPadding)}>
        <Media
          src={fileSrc}
          alt={`pdf as image`}
          type={'fitted image'}
          page={index + 1}
        />
      </div>
    </div>
  ));
};

export const mapImageRows = ({
                               files,
                               firstPageHeader,
                               className,
                             }) => {
  const images = (Array.isArray(files) ? files : [])
    .map(file => ({file, src: file && getFullDataURI(file)}))
    .filter(({src}) => Boolean(src));

  return chunk(images, IMAGES_PER_ROW).map((row, rowIndex) => (
    <div className={className} key={rowIndex}>
      {rowIndex === 0 && Boolean(firstPageHeader) && (
        <div>{firstPageHeader}</div>
      )}
      <div className={classnames(styles.imagesRow, styles.bottomPadding)}>
        {row.map(({file, src}, cellIndex) => (
          <div className={styles.imageCell} key={cellIndex}>
            <div className={classnames(styles.freeText, styles.bold, styles.textRegular)}>
              {file?.free_text ?? '\u00A0'}
            </div>
            <Media
              src={src}
              alt={`fitted image`}
              type={'fitted image'}
            />
          </div>
        ))}
      </div>
    </div>
  ));
};

export const mapImages = ({file, firstPageHeader, className}) =>
  mapImageRows({files: file ? [file] : [], firstPageHeader, className});

export const getFiles = (context, header, fileTypeID, customHeader) => {
  const files = fileTypeID === 10
    ? [
      ...findFilesByTypeId(context.files, fileTypeID),
      ...findFilesByTypeId(context.files, 11).filter(item => item.free_id === 100)
    ]
    : findFilesByTypeId(context.files, fileTypeID);

  if (!Array.isArray(files)) {
    return [];
  }

  const result = [];
  let imageBuffer = [];
  let headerUsed = false;

  const takeHeader = () => {
    if (headerUsed) {
      return null;
    }
    headerUsed = true;
    return customHeader ? customHeader : <HeaderLine header={header}/>;
  };

  const flushImages = () => {
    if (imageBuffer.length === 0) {
      return;
    }
    result.push(...mapImageRows({files: imageBuffer, firstPageHeader: takeHeader()}));
    imageBuffer = [];
  };

  files.filter(Boolean).forEach(file => {
    if (getMediaType(file) === 'pdf') {
      flushImages();
      result.push(...mapPDF({file, firstPageHeader: takeHeader()}));
    } else {
      imageBuffer.push(file);
    }
  });

  flushImages();

  return result;
};